




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { getTableKey } from '@/common/utils/searchResult';
import { SearchResponse, SearchResultType } from '@/api/types/index';
import { toLocalDateFormatted } from '@/common/utils/date';
import { getMapElementColour } from '@/common/utils/colour';
import { isCompletedOrClosed } from '@/common/utils/routes';
import { SearchResultTableItem } from '@/types/search';
import { bus } from '@/services/busService';
import { searchMod } from '@/store/modules/search';
import { routeMod } from '@/store/modules/route';

@Component({})
export default class SearchResultsList extends Vue {
  @Prop({ required: true })
  searchResults!: SearchResponse[];

  @Prop({ required: true })
  loadingSearch!: boolean;

  @Prop({ required: false })
  selectedItem!: SearchResponse | null;

  @Prop({ required: true })
  visibleItems!: SearchResponse[];

  @Prop({ required: true })
  completedRoutes!: string[];

  @Watch('displayedItems')
  updateAllVisibility(): void {
    this.checkHighlightedRun();
    searchMod.SET_VISIBLE_ITEMS(this.displayedItems);
  }

  @Watch('searchResults')
  updateDisplayedItems() {
    this.displayedItems = this.visibleItems;
  }

  private displayedItems: SearchResponse[] = [];

  private searchResultHeaders: DataTableHeader[] = [
    {
      text: 'FLEET REF',
      value: 'fleetNumber'
    },
    {
      text: 'REG #',
      value: 'registrationNumber'
    },
    {
      text: 'RUN REF',
      value: 'deliveryRunReference'
    },
    {
      text: 'DATE',
      value: 'startDateTimeUtc'
    }
  ];

  private selectedIndex: number | null = null;

  get tableData(): SearchResultTableItem[] {
    return this.searchResults.map((item) => {
      return {
        id: getTableKey(item),
        ...item
      };
    });
  }

  async created(): Promise<void> {
    this.displayedItems = this.visibleItems;
  }

  private selectedRow(item: SearchResultTableItem): string {
    return getTableKey(this.selectedItem) === item.id ? 'selectedRow' : '';
  }

  private isDisplayedRow(selectedRowId: string): boolean {
    const visibleReferenceList = this.displayedItems.map((item) => getTableKey(item));
    return visibleReferenceList.includes(selectedRowId);
  }

  private selectItem(item: SearchResultTableItem): void {
    if (this.isDisplayedRow(item.id)) {
      this.setSelectedItem(item, this.getItemColour(item, this.getIndexOfItem(item)));
    }
  }

  private checkHighlightedRun(): void {
    if (!this.isDisplayedRow(getTableKey(this.selectedItem))) {
      this.setSelectedItem(null, '');
    }
  }

  private formatDate(date: Date): string {
    return date ? toLocalDateFormatted(date, 'DD/MM/YYYY') : '';
  }

  private searchReultItemColour(item: SearchResultTableItem): any {
    return { 'background-color': this.getItemColour(item, this.getIndexOfItem(item)) };
  }

  private displaySearchResultItem(item: SearchResultTableItem, isSelected: boolean): void {
    if (!isSelected) {
      const colour = this.getItemColour(item, this.getIndexOfItem(item));
      if (item.searchResultType === SearchResultType.trackable) {
        this.setSelectedItem(item, colour);
        this.$emit('panTo', item.trackingDeviceIdentifier);
      } else {
        this.$emit('fetchRoute', item, colour);
      }
    } else {
      const infoWindowReference = {
        deliveryRunReference: item.deliveryRunReference,
        fleetNumber: item.fleetNumber
      };
      bus.$emit('closeInfoWindow', infoWindowReference);
    }
  }

  private setSelectedItem(item: SearchResultTableItem | null, colour: string): void {
    searchMod.SET_SELECTED_ITEM(item);
    searchMod.SET_SELECTED_ITEM_COLOUR(colour);
    if (item && item.searchResultType === SearchResultType.route) {
      routeMod.setSelectedRouteTrackingData(item.deliveryRunReference);
    } else {
      routeMod.setSelectedRouteTrackingData(null);
    }
  }

  private displayAllItems(isOn: boolean): void {
    if (!isOn) {
      this.$emit('fetchRoutes');
    } else {
      bus.$emit('closeInfoWindow', null);
    }
  }

  private getItemColour(item: SearchResponse, index: number): string {
    if (item.searchResultType === SearchResultType.route) {
      return this.completedRoutes.includes(item.deliveryRunReference) || isCompletedOrClosed(item.routeStatus)
        ? '#757576'
        : getMapElementColour(index);
    } else {
      return isCompletedOrClosed(item.routeStatus) ? '#757576' : getMapElementColour(index);
    }
  }

  private getIndexOfItem(item: SearchResultTableItem): number {
    return this.tableData.indexOf(item);
  }
}
